import Phaser from "phaser";
import { createGameConfig } from "./config";

const StartGame = (parent: string) => {
  return new Phaser.Game(createGameConfig(parent));
};

export default StartGame;
